import {
    AuthorizationErrorMaintainerEnphaseTroubleshooting,
    AuthorizationErrorSolaredgeTroubleshooting,
    AuthorizationErrorEnphaseTroubleshooting,
    AuthorizationErrorGeneracTroubleshooting,
    IntegrationUpdateRequiredTroubleshooting,
    MissingIntegrationGeneracTroubleshooting,
    UnsupportedManufacturerTroubleshooting,
    AuthorizationErrorTroubleshooting,
    MissingIntegrationTroubleshooting,
    TeslaTroubleshooting,
    Button,
    IconPasscode,
    IconPasscodeLock,
    IconSearchFile01,
    IconSlashCircle01,
    IconSize
} from '@/components'
import { SystemStatusEnum } from '@/enums'
import { SystemStatusDataType } from '@/types'

export const SYSTEM_STATUSES_EXCLUDED: SystemStatusDataType[] = [
    {
        value: SystemStatusEnum.AUTH_ERROR,
        title: 'Authorization Error',
        refreshable: true,
        icon: (size: IconSize) => <IconSearchFile01 size={size}/>,
        troubleshooting: {
            solaredge: <AuthorizationErrorSolaredgeTroubleshooting/>,
            enphase: <AuthorizationErrorEnphaseTroubleshooting/>,
            generac: <AuthorizationErrorGeneracTroubleshooting/>,
            maintainer: { enphase: <AuthorizationErrorMaintainerEnphaseTroubleshooting/> },
            default: <AuthorizationErrorTroubleshooting/>
        },
        description: 'We have located this system in the inverter manufacturer\'s database, but Solar Insure lacks' +
            ' the necessary permissions to access the monitoring data. This is often due to restrictive settings or' +
            ' insufficient access rights configured in the monitoring portal or system.'
    },
    {
        value: SystemStatusEnum.UNKNOWN_MANUFACTURER,
        title: 'Unsupported Manufacturer',
        icon: (size: IconSize) => <IconSlashCircle01 size={size}/>,
        description: 'Monitoring is currently unavailable for this inverter manufacturer on the Daybreak Platform.' +
            ' However, claims for inverters on our AVL will still be honored. To get assistance from Solar Insure for' +
            ' troubleshooting or expediting claims, you can provide your manufacturer monitoring portal credentials' +
            ' in the Integrations tab in your Profile to offer an alternative way to view site issues without the' +
            ' Solar Insure Fleet Monitoring dashboard.',
        action: <Button href="/profile/integrations#unsupported" className="!font-normal">
            Update Credentials
        </Button>,
        troubleshooting: <UnsupportedManufacturerTroubleshooting/>
    },
    {
        value: SystemStatusEnum.INTEGRATION_UPDATE_REQUIRED,
        title: 'Integration Update Required',
        refreshable: true,
        icon: (size: IconSize) => <IconPasscodeLock size={size}/>,
        description: 'Your monitoring credentials for one or more inverter manufacturers are invalid. To enable Solar' +
            ' Insure Monitoring updates, please update your credentials and check back for a revised connection status',
        action: <Button href="/profile/integrations" className="!font-normal">
            Update Credentials
        </Button>,
        troubleshooting: <IntegrationUpdateRequiredTroubleshooting/>
    },
    {
        value: SystemStatusEnum.MISSING_INTEGRATION,
        title: 'Missing Integration',
        refreshable: true,
        icon: (size: IconSize) => <IconPasscode size={size}/>,
        description: {
            tesla: 'We couldn’t connect this site, and your company hasn’t submitted Tesla integration credentials on' +
                ' the Integrations tab or successfully connected any other Tesla warranties. Make sure this warranty' +
                ' has a valid DIN and that the site has been shared with Solar Insure in Powerhub.',
            default: 'You are missing the required fleet monitoring credentials for one or more inverter manufacturers.'
        },
        action: <Button href="/profile/integrations" className="!font-normal">
            Update Credentials
        </Button>,
        troubleshooting: {
            generac: <MissingIntegrationGeneracTroubleshooting/>,
            tesla: <TeslaTroubleshooting/>,
            default: <MissingIntegrationTroubleshooting/>
        }
    }
]
